import React from "react";
import styled from "styled-components";

import theme from "../../styles/theme";
import Link from "../util/standardize-link";
import GAEvent from "../util/GAEvent";

import BasicArrow from "./svgs/BasicArrow";

const { colors, button, font } = theme;

const Button = styled(Link)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-family: ${font.bold};
	text-align: center;
	font-size: 16px;
	cursor: pointer;
	min-width: 150px;
	width: fit-content;

	padding: ${(props) => (props.secondary ? "0px" : "15px 20px")};
	border-radius: ${(props) => (props.secondary ? 0 : "30px")};

	.link-arrow {
		margin-left: 9px;
		transition: margin-left 0.25s ease-in;
	}

	:hover {
		.link-arrow {
			margin-left: 15px;
		}
	}
	
	${(props) => props.secondary ? `		
		min-width: fit-content;
		background: linear-gradient(${colors.brandMain}, ${colors.brandMain});
		background-size: 0 2px;
		background-position: 0 100%;
		background-repeat: no-repeat;
		transition: all 0.25s ease-in;
		color: ${colors.newBrand.black};

		.link-arrow {
			transition: all 0.25s ease-in;
			stroke: ${colors.newBrand.black};
		}

		:hover {
			background-size: 100% 2px;
			color: ${colors.brandMain};

			.link-arrow {
				stroke: ${colors.brandMain};
			}
		}
	`:`
		background: ${colors.brandMain};	
		transition: background 0.25s ease-in;
		color: ${colors.white};

		.link-arrow {
			stroke: ${colors.white};
		}

		:hover {
			background: ${colors.newBrand.brandDark};
			color: ${colors.white};
		}
	`};
`;

const ButtonContents = ({ gaEvent, children }) => {
	return gaEvent ? <GAEvent {...gaEvent}>{children}</GAEvent> : children;
};

export default ({ type, arrow, secondary, tertiary, anchorLink, offset, onClick, gaEvent, className, ...props }) => {
	return (
		<Button 
			anchorLink={!props.disabled && anchorLink} 
			to={!props.disabled && props.link} 
			onClick={!props.disabled && onClick} 
			role="button"
			secondary={secondary}
			className={`${className} basic__button`}
			{...props}
		>
			<ButtonContents gaEvent={gaEvent}>{props.children}</ButtonContents>
			{arrow && <BasicArrow className="link-arrow" />}
		</Button>
	)
};
